import { Typography } from 'antd';
import { useNavigate } from 'react-router';
import tw from 'twin.macro';

import { PATH } from '@/Route';
import Card from '@/components/Card';
import Grid from '@/components/list/Grid';
import PriceItemBox from '@/components/product/ProductItem/PriceItem';
import { useProducts } from '@/hooks/queries/partner';
import usePagination from '@/hooks/usePagination';

const ProductList = () => {
  const pagination = usePagination([], {
    defaultSize: 15,
  });
  const navigate = useNavigate();
  const query = useProducts({ ...pagination.query });

  return (
    <Grid
      itemKey={(data) => data.id.toString()}
      headerConfig={{
        showTotalCount: true,
        showSizeSelector: true,
        sizeOptions: [15, 45, 90],
      }}
      dataSource={query.data?.results}
      onClickItem={(data) => {
        navigate(`${PATH.MARKETING_PRODUCT.INDEX}/${data.id}`);
      }}
      emptyText="등록된 상품이 없어요"
      renderItem={(data) => {
        return (
          <Card
            css={[
              tw`[.ant-card-body]:(flex flex-col items-start w-full)`,
              tw`[img]:(w-full aspect-[3/2] object-cover)`,
            ]}
          >
            <img
              alt={`${data.name} 썸네일`}
              src={data.bannerImageUrl}
              onDragStart={(e) => e.preventDefault()}
            />

            <Typography.Text
              css={tw`mt-[24px] font-semibold leading-[24px] text-[16px] text-black`}
            >
              {data.name}
            </Typography.Text>
            <Typography.Text css={tw`mt-[8px] leading-[22px] text-[14px]`}>
              {data.summary}
            </Typography.Text>

            <PriceItemBox
              price={data.price}
              discountPrice={data.discountPrice || 0}
            />
          </Card>
        );
      }}
      pagination={{ total: query.data?.count, ...pagination }}
    />
  );
};

export default ProductList;
